import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { Box, Tooltip } from '@mui/material';

const OverflowTooltip = ({ children, ...props }) => {
    const ref = useRef(null);
    const [isOverflown, setIsOverflown] = useState(false);
    const compareSize = () => {
        const element = ref.current;
        setIsOverflown(element.scrollWidth > element.clientWidth);
    };
    // compare once and add resize listener on "componentDidMount"
    useEffect(() => {
        compareSize();
        window.addEventListener('resize', compareSize);
    }, []);

    // remove resize listener again on "componentWillUnmount"
    useEffect(
        () => () => {
            window.removeEventListener('resize', compareSize);
        },
        []
    );

    return (
        <Tooltip
            interactive="true"
            disableHoverListener={!isOverflown}
            title={children}
            label={children}
            isDisabled={!isOverflown}
            componentsProps={{
                tooltip: { sx: { backgroundColor: '#272727', fontSize: '10px' } },
                arrow: { sx: { color: '#272727' } },
            }}
        >
            <Box sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} ref={ref} {...props}>
                {children}
            </Box>
        </Tooltip>
    );
};
OverflowTooltip.propTypes = {
    children: PropTypes.any,
};

OverflowTooltip.defaultProps = {
    children: '',
};

export default React.memo(OverflowTooltip);
